<ng-container>
	@if (clientListItems(); as clientListItems) {
	<lib-card [title]="'Select client'" [subtitle]="'Keep in touch with your clients'">
		<lib-list
			[avatarSize]="'50px'"
			[enableSearch]="true"
			[design]="'selectionList'"
			[showNameBasedAvatar]="true"
			[enableSearch]="true"
			[hideSelectIcon]="true"
			[items]="clientListItems"
			[noItemsText]="'You have no clients'"
		></lib-list>
	</lib-card>
	}
</ng-container>
